import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiMeta.html'),
    bindings: {
    },
})
export class FiMeta {
    static $inject = [
        '$http',
        '$scope',
        '$window',
    ];

    constructor(
        private $http: angular.IHttpService,
        private $scope: angular.IScope,
        private $window: angular.IWindowService,
    ) {
    }

    pages = [];

    title: string;
    keywords: string;
    description: string;

    $onInit() {

        this.$http.get('https://www.fitit.lt/db/seo-list.php').then((data) => {
            this.pages.push(data);

            this.title = 'Fitit – Nestandartiniai baldai pagal užsakymą, Vilniuje (4-6 sav.)';
            this.keywords = 'nestandartiniai baldai; baldai pagal užsakymą; spintos; komodos; lentynos; TV spintelės; korpusiniai baldai; baldų gamyba Vilniuje; baldų konfiguratorius';
            this.description = 'UAB Fitit gamina nestandartinius korpusinius baldus (spintos, spinteles, komodos, lentynos ir kt.) pagal užsakymą Vilniuje ir Kaune. Naudojamos kokybiškos geriausių Europos gamintojų medžiagos. Terminas: 4–6 sav. Garantija: 24 mėn. Pasinaudok mūsų konfiguratoriumi ir sužinok savo individualaus baldo kainą iš karto.';
        });

        this.$scope.$watch(() => this.$window.location.pathname.replace(/[\/\\]/g, ''), () => {

            if (!this.pages[0]) return;
            for(const page of this.pages[0].data) {
                if (page.url == this.$window.location.pathname.replace(/[\/\\]/g, '')) {
                    this.title = page.title;
                    this.keywords = page.keywords;
                    this.description = page.description;
                }
            }

            if (!this.title) {
                this.title = 'Fitit – Nestandartiniai baldai pagal užsakymą, Vilniuje (4-6 sav.)';
                this.keywords = 'nestandartiniai baldai; baldai pagal užsakymą; spintos; komodos; lentynos; TV spintelės; korpusiniai baldai; baldų gamyba Vilniuje; baldų konfiguratorius';
                this.description = 'UAB Fitit gamina nestandartinius korpusinius baldus (spintos, spinteles, komodos, lentynos ir kt.) pagal užsakymą Vilniuje ir Kaune. Naudojamos kokybiškos geriausių Europos gamintojų medžiagos. Terminas: 4–6 sav. Garantija: 24 mėn. Pasinaudok mūsų konfiguratoriumi ir sužinok savo individualaus baldo kainą iš karto.';
            }
          
        });

    }

}
